import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import AddToMultipleWatchlistDialog from 'components/watchlist/AddToMultipleWatchlistDialog';
import { addTickerToWatchlist, removeTickerFromWatchlist } from 'components/homePage/HomePageActions';
import { updateTickerStatusInDomesticIndexDB } from 'indexDb/dexie';
import { updateCompleteCompaniesData } from 'components/watchlist/WatchlistHelpers';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import { useLocation } from 'react-router-dom';

const AddRemoveWatchlist = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();
  const selectedItem = useSelector(state => state.Watchlist.selectedItem);
  const [isAddToWatchlistDialog, setIsAddToWatchlistDialog] = useState(false);
  const [isTickerActive, setIsTickerActive] = useState(false);

  useEffect(() => {
    setIsTickerActive(selectedItem?.isTickerActive ?? false);
  }, [selectedItem]);

  const addToWatchlistClickHandler = selectedCategories => {
    const PayloadData = [{ ticker: selectedItem.ticker, company_id: selectedItem.companyId }];
    dispatch(addTickerToWatchlist(PayloadData, selectedCategories));
    updateStatusInStates();
  };

  const updateStatusInStates = () => {
    setIsTickerActive(prevState => !prevState);
    if (isEmpty(selectedItem.documentType) || ['10-K', '10-Q'].includes(selectedItem.documentType)) {
      dispatch(updateCompleteCompaniesData(selectedItem.companyId));
      updateTickerStatusInDomesticIndexDB(selectedItem.companyId, !isTickerActive);
    }
  };
  const handleStarClicked = () => {
    if (isTickerActive) {
      dispatch(removeTickerFromWatchlist(selectedItem.companyId));
      updateStatusInStates();
    } else {
      setIsAddToWatchlistDialog(true);
    }
  };

  return (
    <>
      <Box className={classes.starTickerBtnBox}>
        {!['/home', '/watchlist', '/social-screener'].includes(location.pathname) ? (
          <Button className={classes.starBtnContainer} onClick={handleStarClicked}>
            <Tooltip arrow title={isTickerActive ? 'Remove from Watchlist' : 'Add to Watchlist'}>
              {isTickerActive ? <StarIcon className={classes.star} /> : <StarBorderIcon className={classes.star} />}
            </Tooltip>
          </Button>
        ) : null}
      </Box>
      {isAddToWatchlistDialog && (
        <AddToMultipleWatchlistDialog
          onClose={() => setIsAddToWatchlistDialog(false)}
          onAddToWatchlistClick={addToWatchlistClickHandler}
        />
      )}
    </>
  );
};

export default AddRemoveWatchlist;

const useStyles = makeStyles(() => ({
  starTickerBtnBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  starBtnContainer: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    border: 'none',
    padding: '0px',
    margin: '0px',
    marginRight: '4px',
    minWidth: 'fit-content',
  },
  star: {
    fontSize: '24px',
    cursor: 'pointer',
  },
}));
